import React from 'react';
import AboutMe from "../ReceptionistComponents/me/Me"

const FifthScreenRec = () => {
  return <>
      <AboutMe/>
 </>
  
};

export default FifthScreenRec;
